import dynamic from 'next/dynamic'
import StyleGuideLoading from 'shared/library/pages/StyleGuide/StyleGuideLoading'

/**
 * Warning
 * -----------------------------------------------------------------
 * This Type is file via Node - createStyleGuide.js
 *
 * Run "yarn update-styleguide" to update this file.
 * -----------------------------------------------------------------
 */

export const STYLE_GUIDE = {
  articleCard: {
    id: 'articleCard',
    title: 'Article Card',
    Component: dynamic(
      () => import('library/organisms/ArticleCard/ArticleCard.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  banner: {
    id: 'banner',
    title: 'Banner',
    Component: dynamic(
      () => import('library/molecules/BannerBar/BannerBar.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  breadcrumb: {
    id: 'breadcrumb',
    title: 'Breadcrumb',
    Component: dynamic(
      () => import('library/molecules/Breadcrumb/Breadcrumbs.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  button: {
    id: 'button',
    title: 'Button',
    Component: dynamic(() => import('library/atoms/Button/Button.styleguide'), {
      loading: StyleGuideLoading
    })
  },
  calendar: {
    id: 'calendar',
    title: 'Calendar',
    Component: dynamic(
      () => import('library/molecules/Calendar/Calendar.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  carousel: {
    id: 'carousel',
    title: 'Carousel',
    Component: dynamic(
      () => import('library/molecules/Carousel/Carousel.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  checkbox: {
    id: 'checkbox',
    title: 'Checkbox',
    Component: dynamic(
      () => import('library/atoms/Checkbox/Checkbox.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  conditionalwrapper: {
    id: 'conditionalwrapper',
    title: 'Conditional Wrapper',
    Component: dynamic(
      () =>
        import(
          'shared/library/atoms/ConditionalWrapper/ConditionalWrapper.styleguide'
        ),
      { loading: StyleGuideLoading }
    )
  },
  contenthero: {
    id: 'contenthero',
    title: 'Content Hero',
    Component: dynamic(
      () => import('library/molecules/ContentHero/ContentHero.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  countdown: {
    id: 'countdown',
    title: 'Countdown',
    Component: dynamic(
      () => import('library/atoms/Countdown/Countdown.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  coverimage: {
    id: 'coverimage',
    title: 'Cover Image',
    Component: dynamic(
      () => import('library/atoms/CoverImage/CoverImage.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  detailslist: {
    id: 'detailslist',
    title: 'Details List',
    Component: dynamic(
      () => import('library/molecules/DetailsList/DetailsList.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  divider: {
    id: 'divider',
    title: 'Divider',
    Component: dynamic(
      () => import('shared/library/atoms/Divider/Divider.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  embedcode: {
    id: 'embedcode',
    title: 'Embed Code',
    Component: dynamic(
      () => import('shared/library/molecules/EmbedCode/EmbedCode.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  fieldholder: {
    id: 'fieldholder',
    title: 'Field Holder',
    Component: dynamic(
      () => import('library/atoms/FieldHolder/FieldHolder.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  fieldset: {
    id: 'fieldset',
    title: 'Fieldset',
    Component: dynamic(
      () => import('library/atoms/Fieldset/Fieldset.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  filterbox: {
    id: 'filterbox',
    title: 'Filter Box',
    Component: dynamic(
      () => import('library/atoms/FilterBox/FilterBox.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  flex: {
    id: 'flex',
    title: 'Flex',
    Component: dynamic(
      () => import('shared/library/atoms/Flex/Flex.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  grid: {
    id: 'grid',
    title: 'Grid',
    Component: dynamic(() => import('library/atoms/Grid/Grid.styleguide'), {
      loading: StyleGuideLoading
    })
  },
  header: {
    id: 'header',
    title: 'Header',
    Component: dynamic(
      () => import('library/molecules/Header/Header.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  herosection: {
    id: 'herosection',
    title: 'Hero Section',
    Component: dynamic(
      () => import('library/molecules/HeroSection/HeroSection.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  icon: {
    id: 'icon',
    title: 'Icon',
    Component: dynamic(
      () => import('shared/library/atoms/Icon/Icon.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  infobar: {
    id: 'infobar',
    title: 'Info Bar',
    Component: dynamic(
      () => import('library/molecules/InfoBar/InfoBar.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  input: {
    id: 'input',
    title: 'Input',
    Component: dynamic(() => import('library/atoms/Input/Input.styleguide'), {
      loading: StyleGuideLoading
    })
  },
  item: {
    id: 'item',
    title: 'Item',
    Component: dynamic(() => import('library/molecules/Item/Item.styleguide'), {
      loading: StyleGuideLoading
    })
  },
  lineitem: {
    id: 'lineitem',
    title: 'Line Item',
    Component: dynamic(
      () => import('library/molecules/LineItem/LineItem.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  locationtag: {
    id: 'locationtag',
    title: 'Location Tag',
    Component: dynamic(
      () => import('library/molecules/LocationTag/LocationTag.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  map: {
    id: 'map',
    title: 'Map',
    Component: dynamic(
      () => import('shared/library/atoms/Map/Map.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  modal: {
    id: 'modal',
    title: 'Modal',
    Component: dynamic(
      () => import('shared/library/molecules/Modal/Modal.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  pin: {
    id: 'pin',
    title: 'Pin',
    Component: dynamic(() => import('library/molecules/Pin/Pin.styleguide'), {
      loading: StyleGuideLoading
    })
  },
  price: {
    id: 'price',
    title: 'Price',
    Component: dynamic(
      () => import('shared/library/atoms/Price/Price.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  purchasablecardprice: {
    id: 'purchasablecardprice',
    title: 'Purchasable Card Price',
    Component: dynamic(
      () =>
        import(
          'library/molecules/PurchasableCardPrice/PurchasableCardPrice.styleguide'
        ),
      { loading: StyleGuideLoading }
    )
  },
  quantity: {
    id: 'quantity',
    title: 'Quantity',
    Component: dynamic(
      () => import('library/molecules/Quantity/Quantity.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  radiobutton: {
    id: 'radiobutton',
    title: 'Radio Button',
    Component: dynamic(
      () => import('library/atoms/RadioButton/RadioButton.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  rating: {
    id: 'rating',
    title: 'Rating',
    Component: dynamic(
      () => import('library/molecules/Rating/Rating.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  schedulableaction: {
    id: 'schedulableaction',
    title: 'Schedulable Action',
    Component: dynamic(
      () =>
        import(
          'library/molecules/SchedulableAction/SchedulableAction.styleguide'
        ),
      { loading: StyleGuideLoading }
    )
  },
  securedbage: {
    id: 'securedbage',
    title: 'Secured Bage',
    Component: dynamic(
      () => import('library/molecules/SecuredBage/SecuredBadge.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  skeletonloader: {
    id: 'skeletonloader',
    title: 'Skeleton Loader',
    Component: dynamic(
      () =>
        import('shared/library/atoms/SkeletonLoader/SkeletonLoader.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  spinner: {
    id: 'spinner',
    title: 'Spinner',
    Component: dynamic(
      () => import('library/atoms/Spinner/Spinner.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  stripeelementwrapper: {
    id: 'stripeelementwrapper',
    title: 'Stripe Element Wrapper',
    Component: dynamic(
      () =>
        import(
          'library/molecules/StripeElementWrapper/StripeElementWrapper.styleguide'
        ),
      { loading: StyleGuideLoading }
    )
  },
  summary: {
    id: 'summary',
    title: 'Summary',
    Component: dynamic(
      () => import('library/molecules/Summary/Summary.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  tabs: {
    id: 'tabs',
    title: 'Tabs',
    Component: dynamic(
      () => import('shared/library/atoms/Tabs/Tabs.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  tag: {
    id: 'tag',
    title: 'Tag',
    Component: dynamic(() => import('library/atoms/Tag/Tag.styleguide'), {
      loading: StyleGuideLoading
    })
  },
  thumbnail: {
    id: 'thumbnail',
    title: 'Thumbnail',
    Component: dynamic(
      () => import('shared/library/atoms/Thumbnail/Thumbnail.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  typography: {
    id: 'typography',
    title: 'Typography',
    Component: dynamic(
      () => import('library/atoms/Typography/Typography.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  validationerror: {
    id: 'validationerror',
    title: 'Validation Error',
    Component: dynamic(
      () =>
        import('library/molecules/ValidationError/ValidationError.styleguide'),
      { loading: StyleGuideLoading }
    )
  },
  voucherbar: {
    id: 'voucherbar',
    title: 'Voucher Bar',
    Component: dynamic(
      () => import('library/molecules/VoucherBar/VoucherBar.styleguide'),
      { loading: StyleGuideLoading }
    )
  }
}
